import React from 'react'
import styles from './MicrositeLastGeneratedBadge.module.css'
import { RefreshCw, Clock } from 'lucide-react'

/**
 * MicrositeLastGeneratedBadge
 * Shows "last generated at" timestamp with a Regenerate button —
 * used on MicrositeSitemap next to the sitemap URL.
 *
 * Usage:
 *   <MicrositeLastGeneratedBadge
 *     lastGeneratedAt={sitemapConfig.lastGeneratedAt}
 *     onRegenerate={handleGenerate}
 *     loading={generating}
 *   />
 */
const MicrositeLastGeneratedBadge = ({ lastGeneratedAt, onRegenerate, loading = false }) => {
    const formatted = lastGeneratedAt
        ? new Date(lastGeneratedAt.replace(' ', 'T')).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })
        : 'Never generated'

    return (
        <div className={styles.row}>
            <span className={styles.timestamp}>
                <Clock size={12} />
                {formatted}
            </span>
            <button type="button" className={styles.regenBtn} onClick={onRegenerate} disabled={loading}>
                <RefreshCw size={13} className={loading ? styles.spinning : ''} />
                {loading ? 'Generating…' : 'Regenerate'}
            </button>
        </div>
    )
}

export default MicrositeLastGeneratedBadge